import { render, staticRenderFns } from "./UiSkeleton.vue?vue&type=template&id=1710b34b&"
import script from "./UiSkeleton.vue?vue&type=script&lang=js&"
export * from "./UiSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports